import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { GarantieProduitDTO } from '../model/garantie-produit/garantie-produit-dto';
import { UpdateGarantieProduit } from '../model/garantie-produit/update-garantie-produit';
import { CreateGarantieProduit } from '../model/garantie-produit/create-garantie-produit';

@Injectable({
    providedIn: 'root'
  })
  export class GarantieProduitService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findAll() 
    {
        return this._restClientService.load<GarantieProduitDTO[]>('garantie-produit/find-all');
    }
 
    findAllNotCheckedByfaciliteId(faciliteId) 
    {
        return this._restClientService.load<GarantieProduitDTO[]>('garantie-produit/find-not-checked-by-facilite?faciliteId='+faciliteId);
    }

    findAllByProduitId(produitId) 
    {
        return this._restClientService.load<GarantieProduitDTO[]>('garantie-produit/find-all-by-produit?produitid='+produitId);
    }

    findById(id) 
    {
        return this._restClientService.load<GarantieProduitDTO>('garantie-produit/find-by-id/'+id);
    }
    
    update(updateGarantieProduit: UpdateGarantieProduit ) 
    {
        return  this._restClientService.put<UpdateGarantieProduit>('garantie-produit/update', updateGarantieProduit);
    }
       
    add(createGarantieProduit: CreateGarantieProduit ) 
    {
        return  this._restClientService.save<CreateGarantieProduit>('garantie-produit/add', createGarantieProduit);
    }
     
    delete(id) 
    {
        return this._restClientService.delete<any>('garantie-produit/delete/'+id);
    }
  


}      

    